specifierInfoCache